<template>
	<div>
		<div class="main" style="margin-top: 20px;">
			<div class="part_title">
				{{region0_name}}
			</div>
			<div class="part_summary">
				{{region0_summary}}
			</div>
			<div class="part_link" @click="toUrl(region0_url)" style="cursor: pointer;">
				点击进入{{region0_name}}>>
			</div>
			
			<el-row style="margin-top: 20px;">
				<el-col :span="4" v-for="(item, index) in list_biaogan_tuijian" :key="index">
					<div class="biaogan" @mouseenter="doMouseEnter(index)" @mouseleave="doMouseLeave(index)" @click="doMouseClick(index)">
						<div class="biaogan_img">
							<el-image :src="$common.adimgUrl + item.icon" fit="contain" style="width: 50px;"></el-image>
						</div>
						<div class="biaogan_title" :style="{color: biaogan_title_color[index], fontWeight: biaogan_title_fontWeight[index]}">
							{{item.title}}
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		
		<div class="biaogan_part">
			<div class="main" v-show="is_show_biaogan_part[0]">
				<el-row :gutter="80">
					<el-col :span="6">
						<div class="biaogan_part_left_title" @click="toUrl(list_biaogan_tuijian0_left.url)">
							{{list_biaogan_tuijian0_left.title}}
						</div>
						<div class="biaogan_part_left_summary" @click="toUrl(list_biaogan_tuijian0_left.url)">
							{{list_biaogan_tuijian0_left.summary}}
						</div>
					</el-col>
					<el-col :span="18">
						<el-row :gutter="20">
							<el-col :span="8" v-for="(item, index) in list_biaogan_tuijian0" :key="index">
								<div class="biaogan_part_right_icon"></div>
								<div class="biaogan_part_right_title" @click="toUrl(item.url)">{{item.title}}</div>
								<div class="biaogan_part_right_summary">{{item.summary}}</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
			<div class="main" v-show="is_show_biaogan_part[1]">
				<el-row :gutter="80">
					<el-col :span="6">
						<div class="biaogan_part_left_title" @click="toUrl(list_biaogan_tuijian1_left.url)">
							{{list_biaogan_tuijian1_left.title}}
						</div>
						<div class="biaogan_part_left_summary" @click="toUrl(list_biaogan_tuijian1_left.url)">
							{{list_biaogan_tuijian1_left.summary}}
						</div>
					</el-col>
					<el-col :span="18">
						<el-row :gutter="20">
							<el-col :span="8" v-for="(item, index) in list_biaogan_tuijian1" :key="index">
								<div class="biaogan_part_right_icon"></div>
								<div class="biaogan_part_right_title" @click="toUrl(item.url)">{{item.title}}</div>
								<div class="biaogan_part_right_summary">{{item.summary}}</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
			<div class="main" v-show="is_show_biaogan_part[2]">
				<el-row :gutter="80">
					<el-col :span="6">
						<div class="biaogan_part_left_title" @click="toUrl(list_biaogan_tuijian2_left.url)">
							{{list_biaogan_tuijian2_left.title}}
						</div>
						<div class="biaogan_part_left_summary" @click="toUrl(list_biaogan_tuijian2_left.url)">
							{{list_biaogan_tuijian2_left.summary}}
						</div>
					</el-col>
					<el-col :span="18">
						<el-row :gutter="20">
							<el-col :span="8" v-for="(item, index) in list_biaogan_tuijian2" :key="index">
								<div class="biaogan_part_right_icon"></div>
								<div class="biaogan_part_right_title" @click="toUrl(item.url)">{{item.title}}</div>
								<div class="biaogan_part_right_summary">{{item.summary}}</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
			<div class="main" v-show="is_show_biaogan_part[3]">
				<el-row :gutter="80">
					<el-col :span="6">
						<div class="biaogan_part_left_title" @click="toUrl(list_biaogan_tuijian3_left.url)">
							{{list_biaogan_tuijian3_left.title}}
						</div>
						<div class="biaogan_part_left_summary" @click="toUrl(list_biaogan_tuijian3_left.url)">
							{{list_biaogan_tuijian3_left.summary}}
						</div>
					</el-col>
					<el-col :span="18">
						<el-row :gutter="20">
							<el-col :span="8" v-for="(item, index) in list_biaogan_tuijian3" :key="index">
								<div class="biaogan_part_right_icon"></div>
								<div class="biaogan_part_right_title" @click="toUrl(item.url)">{{item.title}}</div>
								<div class="biaogan_part_right_summary">{{item.summary}}</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
			<div class="main" v-show="is_show_biaogan_part[4]">
				<el-row :gutter="80">
					<el-col :span="6">
						<div class="biaogan_part_left_title" @click="toUrl(list_biaogan_tuijian4_left.url)">
							{{list_biaogan_tuijian4_left.title}}
						</div>
						<div class="biaogan_part_left_summary" @click="toUrl(list_biaogan_tuijian4_left.url)">
							{{list_biaogan_tuijian4_left.summary}}
						</div>
					</el-col>
					<el-col :span="18">
						<el-row :gutter="20">
							<el-col :span="8" v-for="(item, index) in list_biaogan_tuijian4" :key="index">
								<div class="biaogan_part_right_icon"></div>
								<div class="biaogan_part_right_title" @click="toUrl(item.url)">{{item.title}}</div>
								<div class="biaogan_part_right_summary">{{item.summary}}</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
			<div class="main" v-show="is_show_biaogan_part[5]">
				<el-row :gutter="80">
					<el-col :span="6">
						<div class="biaogan_part_left_title" @click="toUrl(list_biaogan_tuijian5_left.url)">
							{{list_biaogan_tuijian5_left.title}}
						</div>
						<div class="biaogan_part_left_summary" @click="toUrl(list_biaogan_tuijian5_left.url)">
							{{list_biaogan_tuijian5_left.summary}}
						</div>
					</el-col>
					<el-col :span="18">
						<el-row :gutter="20">
							<el-col :span="8" v-for="(item, index) in list_biaogan_tuijian5" :key="index">
								<div class="biaogan_part_right_icon"></div>
								<div class="biaogan_part_right_title" @click="toUrl(item.url)">{{item.title}}</div>
								<div class="biaogan_part_right_summary">{{item.summary}}</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
		</div>
	
	</div>
</template>

<script>
	export default {
		props: ['region0_name', 'region0_summary', 'region0_url'],
		data() {
			return {
				is_show_biaogan_part: [true, false, false, false, false, false],
				biaogan_title_color: ['#055bcc', '#333', '#333', '#333', '#333', '#333'],
				biaogan_title_fontWeight: ['bold', 'normal', 'normal', 'normal', 'normal', 'normal'],
				
				list_biaogan_tuijian: [],
				
				list_biaogan_tuijian0_left: {},
				list_biaogan_tuijian0: [],
				
				list_biaogan_tuijian1_left: {},
				list_biaogan_tuijian1: [],
				
				list_biaogan_tuijian2_left: {},
				list_biaogan_tuijian2: [],
				
				list_biaogan_tuijian3_left: {},
				list_biaogan_tuijian3: [],
				
				list_biaogan_tuijian4_left: {},
				list_biaogan_tuijian4: [],
				
				list_biaogan_tuijian5_left: {},
				list_biaogan_tuijian5: [],
				
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.loadBiaoganTuijian()
			this.loadBiaoganTuijianList()
		},
		
		methods: {
			// 当鼠标进入标杆企业库区域时
			doMouseEnter(index) {
				for (let i=0; i<this.is_show_biaogan_part.length; i++) {
					if (i == index) {
						this.$set(this.is_show_biaogan_part, i, true)
						this.$set(this.biaogan_title_color, i, '#055bcc')
						this.$set(this.biaogan_title_fontWeight, i, 'bold')
					} else {
						this.$set(this.is_show_biaogan_part, i, false)
						this.$set(this.biaogan_title_color, i, '#333')
						this.$set(this.biaogan_title_fontWeight, i, 'normal')
					}
				}
			},
			
			// 当鼠标离开标杆企业库区域时
			doMouseLeave(index) {
				for (let i=0; i<this.is_show_biaogan_part.length; i++) {
					if (i == index) {
						this.$set(this.is_show_biaogan_part, i, true)
						this.$set(this.biaogan_title_color, i, '#055bcc')
						this.$set(this.biaogan_title_fontWeight, i, 'bold')
					} else {
						this.$set(this.is_show_biaogan_part, i, false)
						this.$set(this.biaogan_title_color, i, '#333')
						this.$set(this.biaogan_title_fontWeight, i, 'normal')
					}
				}
			},
			
			doMouseClick(index) {
				console.log('mouse click ' + index)
			},
			
			
			// 加载标杆企业推荐
			loadBiaoganTuijian() {
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10002').then((res) => {
					this.list_biaogan_tuijian = eval('(' + res.data.data.configJson + ')')
				})
			},
			
			// 加载标杆企业推荐列表
			loadBiaoganTuijianList() {
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10003').then((res) => {
					let list = eval('(' + res.data.data.configJson + ')')
					// console.log(list)
					list.forEach((item, index) => {
						if (index == 0) {
							this.list_biaogan_tuijian0_left = item
						} else {
							this.list_biaogan_tuijian0.push(item)
						}
					})
				})
				
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10004').then((res) => {
					let list = eval('(' + res.data.data.configJson + ')')
					list.forEach((item, index) => {
						if (index == 0) {
							this.list_biaogan_tuijian1_left = item
						} else {
							this.list_biaogan_tuijian1.push(item)
						}
					})
				})
				
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10005').then((res) => {
					let list = eval('(' + res.data.data.configJson + ')')
					list.forEach((item, index) => {
						if (index == 0) {
							this.list_biaogan_tuijian2_left = item
						} else {
							this.list_biaogan_tuijian2.push(item)
						}
					})
				})
				
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10006').then((res) => {
					let list = eval('(' + res.data.data.configJson + ')')
					list.forEach((item, index) => {
						if (index == 0) {
							this.list_biaogan_tuijian3_left = item
						} else {
							this.list_biaogan_tuijian3.push(item)
						}
					})
				})
				
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10007').then((res) => {
					let list = eval('(' + res.data.data.configJson + ')')
					list.forEach((item, index) => {
						if (index == 0) {
							this.list_biaogan_tuijian4_left = item
						} else {
							this.list_biaogan_tuijian4.push(item)
						}
					})
				})
				
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10008').then((res) => {
					let list = eval('(' + res.data.data.configJson + ')')
					list.forEach((item, index) => {
						if (index == 0) {
							this.list_biaogan_tuijian5_left = item
						} else {
							this.list_biaogan_tuijian5.push(item)
						}
					})
				})
				
			},
			
			// web配置数据链接跳转
			toUrl(url) {
				console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
			},
			
			
			
		}
	}
</script>

<style>
</style>